function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "path",
  d: "M12.489,2.5c4.864,0,9.2,4.583,8.988,9.649-.211,5.548-6.556,16.885-8.988,16.885S3.712,17.817,3.5,12.149C3.289,7.083,7.624,2.5,12.489,2.5Zm0,24,.952-1.085a40.058,40.058,0,0,0,2.538-3.859c2.009-3.5,3.278-7.116,3.384-9.407a7.224,7.224,0,0,0-6.873-7.237,7.224,7.224,0,0,0-6.873,7.237C5.721,14.561,6.99,18.059,9,21.556a26.767,26.767,0,0,0,2.538,3.859,4.36,4.36,0,0,0,.952,1.085Zm0-9.528a4.037,4.037,0,0,1-3.7-4.221,4.037,4.037,0,0,1,3.7-4.221,4.037,4.037,0,0,1,3.7,4.221,4.037,4.037,0,0,1-3.7,4.221Zm0-2.412a1.752,1.752,0,0,0,1.586-1.809,1.752,1.752,0,0,0-1.586-1.809A1.752,1.752,0,0,0,10.9,12.752a1.752,1.752,0,0,0,1.586,1.809Z",
  transform: "translate(-3.493 -2.5)",
  fill: "rgba(246,137,6,0.6)"
});

var SvgIconMarkerOrange = function SvgIconMarkerOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.992,
    height: 26.534,
    viewBox: "0 0 17.992 26.534",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMarkerOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-marker-orange.41bd2f24.svg";
export { ForwardRef as ReactComponent };